import { FadeUp, ButtonPrimary } from "./Reveal";

export const CTABand = ({
  title = "Een project of onderhoud gepland?",
  text = "Vertel kort wat je zoekt. Ik denk met je mee en maak een heldere, vrijblijvende offerte.",
  buttonLabel = "Vraag een offerte aan",
}) => (
  <section data-testid="cta-band" className="border-y-4 border-cream bg-[#EFEDE8]">
    <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-6 px-4 py-10 sm:flex-row sm:items-center sm:px-6">
      <FadeUp>
        <h2 className="font-display text-2xl font-bold uppercase tracking-wide text-[#111111] sm:text-3xl">
          {title}
        </h2>
        <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-[#555555]">
          {text}
        </p>
      </FadeUp>
      <FadeUp delay={0.1} className="shrink-0">
        <ButtonPrimary to="/contact" testid="cta-band-button">
          {buttonLabel}
        </ButtonPrimary>
      </FadeUp>
    </div>
  </section>
);
